<template>
  <div class="flex h-full w-full flex-col items-center gap-2 px-4">
    <p
      class="text-ontick-steel-500 text-center text-lg font-semibold dark:font-medium dark:text-gray-300"
    >
      Financeiro
    </p>
    <ontick-number-input-component
      size="full"
      :value="value"
      @input="formatInput"
      :min="investment.min_volume"
      :max="investment.max_absolute_volume"
      :step="1000"
      :currency="true"
      :disabled="investment.status === 'RUNNING'"
    />
  </div>
</template>

<script>
import ontickNumberInputComponent from "../../../../../../shared/components/basic/ontick-number-input.component.vue";

export default {
  components: { ontickNumberInputComponent },
  props: {
    investment: {
      type: Object,
    },
    value: {
      type: [String, Number],
    },
  },

  methods: {
    formatInput(event) {
      this.$emit("input", event);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  @apply bg-ontick-steel-500 flex h-full w-10 items-center justify-center rounded border-0 text-sm font-bold;
}
</style>
